import { SOLIDARITY_STATES, SOLIDARITY_QUESTION_SETTINGS, SOLIDARITY_QUESTION_ACCEPT } from 'solidarity.module/common/domain/constants';

class SolidarityRequestModalController {
  constructor($translate, EventEmitter) {
    'ngInject';
    this.translate = $translate;
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.options = SOLIDARITY_QUESTION_SETTINGS;
    this.acceptOptions = SOLIDARITY_QUESTION_ACCEPT;
    this._translate();
  }

  isApproved() {
    return this.modalState === SOLIDARITY_STATES.SUCCESS;
  }

  isFailed() {
    return this.modalState === SOLIDARITY_STATES.FAILED;
  }

  isDeleted() {
    return this.modalState === SOLIDARITY_STATES.DELETED;
  }

  isFailedCancel() {
    return this.modalState === SOLIDARITY_STATES.FAILED_CANCELATION;
  }

  isQuestionCancel() {
    return this.modalState === SOLIDARITY_STATES.QUESTION_CANCEL;
  }

  isQuestionAccept() {
    return this.modalState === SOLIDARITY_STATES.QUESTION_ACCEPT;
  }

  acceptCancel($event) {
    if ($event.selection === SOLIDARITY_STATES.CANCEL) {
      this.onCancel(this.EventEmitter({ ong: this.ong }));
    }
  }

  acceptDonation($event) {
    if ($event.selection === SOLIDARITY_STATES.ACCEPT) {
      this.onCreate(this.EventEmitter({ ong: this.ong, amount: this.amount}));
    }
  }

  _translate() {
    this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.CANCEL_QUESTION_MODAL.DESCRIPTION_MSG1').then((translation) => {
      this.messageQuestionCancelPart1 = translation;

    });

    this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.CANCEL_QUESTION_MODAL.DESCRIPTION_MSG2').then((translation) => {
      this.messageQuestionCancelPart2 = translation;
    });

    this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DESCRIPTION_MSG1').then((translation) => {
      this.messageSuccessPart1 = translation;
    });

    this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DESCRIPTION_MSG2').then((translation) => {
      this.messageSuccessPart2 = translation;
    });

    this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.ACCEPT_QUESTION_MODAL.ACCEPT_MSG1').then((translation) => {
      this.messageQuestionAccetpPart1 = translation;
    });

    this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.ACCEPT_QUESTION_MODAL.ACCEPT_MSG2').then((translation) => {
      this.messageQuestionAccetpPart2 = translation;
    });
  }

  getMessageQuestionCancel() {
    return `${this.messageQuestionCancelPart1} ${this.ong.contribution.amount} € ${this.messageQuestionCancelPart2} <br> ${this.ong.name}`;
  }

  getMessageSuccess() {
    return `${this.messageSuccessPart1} ${this.amount} € ${this.messageSuccessPart2} <br> ${this.ong.name}`;
  }

  getMessageQuestionAccept(){
    return `${this.messageQuestionAccetpPart1} ${this.amount} € ${this.messageQuestionAccetpPart2} <br> ${this.ong.name}`;
  }
}

export default SolidarityRequestModalController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/solidarityRequestModal/solidarityRequestModal.controller.js